import React from "react";

const SideImage = ({ image, positions }) => {
  return (
    <>
      <div className="flex-flex_001 w-full lg:w-1/2 xl:w-2/5 px-4 max-h-max ">
        <div className="relative max-w-xl mx-auto lg:mx-0 lg:max-w-3xl h-screen">
          <div className="bg-login-side-bg block w-full object-cover bg-cover sm:h-full h-1/2" />
          <div
            className={`absolute bg-cover bg-center ${
              positions ? positions : "bottom-0"
            }`}
          >
            <img className="block w-full object-cover" src={image} alt="" />
          </div>
        </div>
      </div>
    </>
  );
};

export default SideImage;
